import { GynMedicationsAndSupplementsData, medicationsAndSupplementsField } from '@hb/shared'
import { useUpdateDoc } from '@hooks/backend/useUpdateDoc'
import { useCallback } from 'react'
import { useProfile } from '../../contexts/user/ProfileContext'
import { GenericEditModal } from '../DataView/GenericEditModal'

export const PatientMedicationsModal = ({
  isOpen,
  onClose,
  onSaved,
}: {
  isOpen: boolean
  onClose: () => void
  onSaved?: () => void
}) => {
  const { user, patientRef } = useProfile()

  const update = useUpdateDoc('medications')

  const onSubmit = useCallback(
    async (data: GynMedicationsAndSupplementsData) => {
      if (!patientRef) return { error: 'Patient not found' }
      const result = await update(patientRef, 'gyn.corrections.medicationsAndSupplements', data)
      if (!result?.error) onSaved?.()
      return result
    },
    [update, patientRef, onSaved],
  )

  return (
    <GenericEditModal
      field={medicationsAndSupplementsField}
      data={user?.gyn?.mergedData?.medicationsAndSupplements}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}
